import { BehaviorSubject, Subscription } from 'rxjs';
import { OnInit, Component, EventEmitter, Input, OnDestroy, Output, QueryList, ViewChildren, AfterViewInit } from '@angular/core';
import { Collection } from 'src/lib/fliko/types/database.type';
import { RWDService } from 'src/app/view/user-context/services/rwd.service';
import { FilterConfig } from '../../models/filter-options.model';
import { FilterOptionsComponent } from '../filter-options/filter-options.component';

@Component({
  selector: 'app-filters-array[config]',
  templateUrl: './filters-array.component.html',
  styleUrls: ['./filters-array.component.scss']
})
export class FiltersArrayComponent<T> implements OnInit, AfterViewInit, OnDestroy {
  @Input() config: FilterConfig<T>[] = [];

  @Output() options = new EventEmitter<Collection<T | T[]>>();

  public options$ = new BehaviorSubject<Collection<T | T[]> | null>(null);

  private subscription$ = new Subscription();

  @ViewChildren(FilterOptionsComponent) private filters = new QueryList<FilterOptionsComponent<T>>();

  constructor(public rwdService: RWDService) {}

  ngOnInit(): void {
    this.subscription$.add(
      this.options$.subscribe((x) => {
        if (x) this.options.emit(x);
      })
    );
  }

  ngAfterViewInit(): void {
    this.setNextOptions();
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }

  public get isDefault(): boolean {
    for (const filter of this.filters) {
      if (!filter.isDefault) return false;
    }
    return true;
  }

  public reset(emitEvent = true): void {
    for (const filter of this.filters) filter.reset(false);
    if (emitEvent) this.setNextOptions();
  }

  public onFilterChange(key: string, value: T | T[]): void {
    this.options$.next({ ...this.options$.value, [key]: value });
  }

  private setNextOptions(): void {
    const value: Collection<T | T[]> = {};
    for (const filter of this.filters) value[filter.config.key] = filter.value;
    this.options$.next(value);
  }
}
